function GraphIcon2({ size = '24', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 3.49157C16.5 3.09596 16.658 2.71656 16.9393 2.43683C17.2206 2.15709 17.6022 1.99994 18 1.99994H21C21.3978 1.99994 21.7794 2.15709 22.0607 2.43683C22.342 2.71656 22.5 3.09596 22.5 3.49157V21.3911H23.25C23.4489 21.3911 23.6397 21.4697 23.7803 21.6096C23.921 21.7494 24 21.9391 24 22.137C24 22.3348 23.921 22.5245 23.7803 22.6643C23.6397 22.8042 23.4489 22.8828 23.25 22.8828H0.75C0.551088 22.8828 0.360322 22.8042 0.21967 22.6643C0.0790176 22.5245 0 22.3348 0 22.137C0 21.9391 0.0790176 21.7494 0.21967 21.6096C0.360322 21.4697 0.551088 21.3911 0.75 21.3911H1.5V16.9162C1.5 16.5206 1.65804 16.1412 1.93934 15.8615C2.22064 15.5818 2.60218 15.4246 3 15.4246H6C6.39782 15.4246 6.77936 15.5818 7.06066 15.8615C7.34196 16.1412 7.5 16.5206 7.5 16.9162V21.3911H9V10.9497C9 10.5541 9.15804 10.1747 9.43934 9.89498C9.72064 9.61525 10.1022 9.45809 10.5 9.45809H13.5C13.8978 9.45809 14.2794 9.61525 14.5607 9.89498C14.842 10.1747 15 10.5541 15 10.9497V21.3911H16.5V3.49157ZM18 21.3911H21V3.49157H18V21.3911ZM13.5 21.3911V10.9497H10.5V21.3911H13.5ZM6 21.3911V16.9162H3V21.3911H6Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-12"
          y1="12.4414"
          x2="8.68234"
          y2="36.2109"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GraphIcon2;
